import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Grid, BillingSettingsModule, Tabs, makeStyles, BillingInfo, Typography, CertificateUpload } from "../../../../"; // import selects from '../../../../assets/selects'
// import { Link } from 'react-router-dom';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    divider: {
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "flex-end"
    },
    tabContainer: {
      display: "flex"
    },
    skeleton: {
      padding: "30px",
      width: "60%"
    }
  };
});

var BillingSettings = function BillingSettings(props) {
  var classes = useStyles(); // console.log("BillingSettings", props);

  var billing_info = props.billing_info,
      series = props.series,
      payment_methods = props.payment_methods,
      translation = props.translation,
      createPaymentMethod = props.createPaymentMethod,
      editPaymentMethod = props.editPaymentMethod,
      deletePaymentMethod = props.deletePaymentMethod,
      createSerie = props.createSerie,
      editSerie = props.editSerie,
      deleteSerie = props.deleteSerie,
      editInfo = props.editInfo,
      columns = props.columns,
      titles = props.titles,
      onUploadStart = props.onUploadStart,
      onSignedUrl = props.onSignedUrl,
      onProgress = props.onProgress,
      onError = props.onError,
      onFinish = props.onFinish,
      server = props.server,
      franchise = props.franchise,
      handleCertificateUpload = props.handleCertificateUpload,
      options = props.options;
  /* Tabs */

  var _useState = useState("payment_methods"),
      _useState2 = _slicedToArray(_useState, 2),
      valueTabs = _useState2[0],
      setValueTabs = _useState2[1];

  var handleTabs = function handleTabs(e, newValue) {
    return setValueTabs(newValue);
  };

  var contentTabHandler = function contentTabHandler() {
    switch (valueTabs) {
      case "payment_methods":
        return /*#__PURE__*/React.createElement(BillingSettingsModule, {
          key: "payment-methods",
          type: "payment_methods",
          data: payment_methods,
          translation: translation ? translation.payment_methods : null,
          createItem: createPaymentMethod,
          editItem: editPaymentMethod,
          deleteItem: deletePaymentMethod,
          columns: columns ? columns.payment_methods : null,
          titles: titles ? titles.payment_methods : null
        });

      case "series":
        return /*#__PURE__*/React.createElement(BillingSettingsModule, {
          key: "series",
          type: "series",
          data: series,
          translation: translation ? translation.series : null,
          createItem: createSerie,
          editItem: editSerie,
          deleteItem: deleteSerie,
          columns: columns ? columns.series : null,
          titles: titles ? titles.series : null
        });

      case "billing_info":
        return /*#__PURE__*/React.createElement(BillingInfo, {
          key: "billing_info",
          variant: "view",
          editInfo: editInfo,
          info: billing_info,
          translation: translation ? translation.billing_info : null
        });

      case "certificate":
        return franchise && /*#__PURE__*/React.createElement(CertificateUpload, {
          key: "certificate",
          variant: "view",
          franchise: franchise,
          onError: onError,
          onFinish: onFinish,
          server: server,
          handleCertificateUpload: handleCertificateUpload
        });

      default:
        return /*#__PURE__*/React.createElement(BillingSettingsModule, {
          key: "payment-methods",
          type: "payment_methods",
          data: payment_methods,
          translation: translation ? translation.payment_methods : null,
          createItem: createPaymentMethod,
          editItem: editPaymentMethod,
          deleteItem: deletePaymentMethod,
          columns: columns ? columns.payment_methods : null,
          titles: titles ? titles.payment_methods : null
        });
    }
  }; // eslint-disable-next-line no-unused-expressions


  return [/*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      color: "#fafafa"
    }
  }, translation ? translation.title : "Settings")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.tabContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Tabs, {
    orientation: "vertical",
    value: valueTabs,
    onChange: handleTabs,
    variant: "fullWidth",
    indicatorColor: "primary",
    textColor: "primary",
    contentTabs: translation ? translation.tabs : [{
      value: "payment_methods",
      label: "Payment methods"
    }, {
      value: "series",
      label: "Series"
    }, {
      value: "billing_info",
      label: "Billing Info"
    }, {
      value: "certificate",
      label: "CErt"
    }]
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 9
    /* style={{ margin: "32px" }} */

  }, contentTabHandler()))];
};

export { BillingSettings };